import _regenerator from "E:/workspace/ysorder/order_admin_client/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "E:/workspace/ysorder/order_admin_client/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _createForOfIteratorHelper from "E:/workspace/ysorder/order_admin_client/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import _defineProperty from "E:/workspace/ysorder/order_admin_client/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.link.js";
import "core-js/modules/web.dom-collections.for-each.js";
import fanyiPic from '@/assets/fanyi.png';
import Sortable from 'sortablejs';
import { getBrandList } from '@/services/product/brand';
import { getSoureareaList } from '@/services/product/sourcearea';
import { getTransportList } from '@/services/sendtypesetting';
import { getCategoryListByParentId } from '@/services/product/category';
import { getLeftcategoryList, getRightcategoryList, getCategoryDetail, sortOrder, editFirstcategory, addFirstcategory, deleteFirstcategory, addSecondcategory, editSecondCategory, getSecondCategoryDetail, deleteSecondcategory, getCategoryIdAndNameList } from '@/services/designCategory';
import linkList from './config.js';
export default {
  name: 'Classification',
  i18n: require('./i18n-designCategory'),
  components: {},
  data: function data() {
    var _this2 = this;
    /* 上传原产地图片验证 */
    var categoryPicValidate = function categoryPicValidate(rule, value, callback) {
      if (_this2.imageUrl == null || _this2.imageUrl == '') {
        callback(new Error(_this2.$t('public.uploadPictureProp')));
      } else {
        callback();
      }
    };
    var sourceColumns = [{
      title: this.$t('designCategory2.serialnumber'),
      scopedSlots: {
        customRender: 'indexNo'
      }
    }, {
      slots: {
        title: 'sourcetTitle' //自定义标头
      },
      dataIndex: 'name',
      key: 'name',
      align: 'center'
    }, {
      title: this.$t('designCategory2.goodsNum'),
      dataIndex: 'productNumber',
      key: 'productNumber',
      align: 'center'
    }
    // {
    // 	title: this.$t('designCategory2.sourceAreaImg'),
    // 	dataIndex: 'dataImg',
    // 	key: 'dataImg',
    // 	scopedSlots: {
    // 		customRender: 'dataImg',
    // 	},
    // 	align:'center'
    // }
    ];
    var bindColumns = [{
      title: this.$t('designCategory2.serialnumber'),
      scopedSlots: {
        customRender: 'defineNo'
      }
    }, {
      slots: {
        title: 'bindTitle' //自定义标头
      },
      dataIndex: 'brandName',
      key: 'brandName',
      align: 'center'
    }, {
      title: this.$t('designCategory2.goodsNum'),
      dataIndex: 'productNumber',
      key: 'productNumber',
      align: 'center'
    }
    // {
    // 	title: this.$t('designCategory2.bindImg'),
    // 	dataIndex: 'dataImg',
    // 	key: 'dataImg',
    // 	scopedSlots: {
    // 		customRender: 'dataImg',
    // 	},
    // 	align:'center'
    // }
    ];
    var transportColumns = [{
      title: this.$t('designCategory2.serialnumber'),
      scopedSlots: {
        customRender: 'indexNo'
      }
    }, {
      slots: {
        title: 'transprtTitle' //自定义标头
      },
      dataIndex: 'name',
      key: 'name',
      align: 'center'
    }, {
      title: this.$t('designCategory2.goodsNum'),
      dataIndex: 'goodsNum',
      key: 'goodsNum',
      align: 'center'
    }
    // {
    // 	title: this.$t('designCategory2.transportImg'),
    // 	dataIndex: 'dataImg',
    // 	key: 'dataImg',
    // 	scopedSlots: {
    // 		customRender: 'dataImg',
    // 	},
    // 	align:'center'
    // }
    ];
    var classifityColumns = [{
      title: this.$t('designCategory2.serialnumber'),
      dataIndex: 'sortIndex',
      key: 'sortIndex'
    }, {
      slots: {
        title: 'classifityTitle' //自定义标头
      },
      dataIndex: 'categoryName',
      key: 'categoryName',
      align: 'center'
    }, {
      title: this.$t('designCategory2.goodsNum'),
      dataIndex: 'productQuantity',
      key: 'productQuantity',
      align: 'center'
    }
    // {
    // 	title: this.$t('designCategory2.classifityImg'),
    // 	dataIndex: 'dataImg',
    // 	key: 'dataImg',
    // 	scopedSlots: {
    // 		customRender: 'dataImg',
    // 	},
    // 	align:'center'
    // }
    ];
    var myColumns = [{
      title: this.$t('designCategory2.serialnumber'),
      dataIndex: 'indexNo',
      key: 'indexNo',
      width: '10%'
    }, {
      slots: {
        title: 'defineTitle' //自定义标头
      },
      dataIndex: 'settingName',
      key: 'settingName',
      align: 'center'
    }, {
      title: this.$t('designCategory2.defineImg'),
      dataIndex: 'dataImg',
      key: 'dataImg',
      scopedSlots: {
        customRender: 'dataImg'
      },
      align: 'center'
    }, {
      title: this.$t('designCategory2.operation'),
      dataIndex: 'action',
      key: 'action',
      scopedSlots: {
        customRender: 'action'
      },
      width: '18%'
    }];
    var firstColumns = [{
      title: this.$t('designCategory2.serialnumber'),
      dataIndex: 'indexNo',
      key: 'indexNo',
      width: '10%'
    }, {
      dataIndex: 'settingName',
      key: 'settingName',
      slots: {
        title: 'classifytitle' //自定义标头
      },
      scopedSlots: {
        customRender: 'settingName' //自定义表格里面的内容
      },
      ellipsis: true,
      width: '25%'
    }, {
      title: this.$t('designCategory2.classifityType'),
      dataIndex: 'settingType',
      key: 'settingType',
      scopedSlots: {
        customRender: 'settingType'
      }
    }, {
      title: this.$t('designCategory2.updatetime'),
      dataIndex: 'lastUpdateTime',
      key: 'lastUpdateTime',
      width: '25%'
    }, {
      title: this.$t('designCategory2.operation'),
      dataIndex: 'action',
      key: 'action',
      scopedSlots: {
        customRender: 'action'
      },
      width: '18%'
    }];
    return {
      updateLoading: false,
      saveLoading: false,
      updateData: {
        type: 4
      },
      action: process.env.VUE_APP_API_BASE_URL + "/common/upload/",
      imageUrl: '',
      level: 0,
      categoryName: '',
      nameErr: this.$t('designCategory2.categorynameprop'),
      categoryLangList: [],
      /* 默认语言对 */
      defaultLangObj: {},
      /* 语言list */
      langList: [],
      defaultSelectedKeys: [],
      //左边树形结构
      leftDateList: [],
      newClass: [],
      //默认展开的父级
      expandedKeys: ['0'],
      checkedKeys: ['0'],
      oneshowFY: true,
      threehowFY: false,
      twoshowFY: false,
      fanyiPic: fanyiPic,
      loading: false,
      //新建，编辑的时候需要用到model
      datavalue: _defineProperty({
        // 类型
        settingType: undefined,
        classifityType: undefined,
        list: [],
        link: linkList.goodsLink
      }, "classifityType", undefined),
      dialogStatus: '',
      textMap: {
        //新建/修改title
        updatefirst: this.$t('designCategory2.editclassification'),
        updatesecond: this.$t('designCategory2.editclassification2'),
        createfirst: this.$t('designCategory2.addfirstcategory'),
        createsecond: this.$t('designCategory2.addsecondcategory')
      },
      visible: false,
      //新建/修改 显示
      columns: [],
      firstColumns: firstColumns,
      transportColumns: transportColumns,
      bindColumns: bindColumns,
      sourceColumns: sourceColumns,
      classifityColumns: classifityColumns,
      myColumns: myColumns,
      isSecondLoading: false,
      secondPagination: {
        pageSizeOptions: ['10', '20', '30'],
        showSizeChanger: true,
        showQuickJumper: true,
        showTotal: function showTotal(total, range) {
          return "".concat(_this2.$t('public.total'), "\uFF1A") + total;
        },
        current: 1,
        pageSize: 10,
        total: 0,
        onChange: function onChange(page, pageSize) {
          _this2.secondPagination.current = page;
          _this2.secondPagination.pageSize = pageSize;
          _this2.getRightList(_this2.leftId);
        },
        onShowSizeChange: function onShowSizeChange(page, pageSize) {
          _this2.secondPagination.current = page;
          _this2.secondPagination.pageSize = pageSize;
          _this2.getRightList(_this2.leftId);
        }
      },
      pagination: false,
      //列表数据
      firstClassifyList: [],
      isTableLoading: false,
      rules: {
        categoryPic: [{
          required: true,
          validator: categoryPicValidate,
          trigger: 'change'
        }]
      },
      classifityTypeList: [{
        id: 0,
        name: this.$t('designCategory2.oldPlace')
      }, {
        id: 1,
        name: this.$t('designCategory2.transportWay')
      }, {
        id: 2,
        name: this.$t('designCategory2.brand')
      }, {
        id: 4,
        name: this.$t('designCategory2.goodsClassifity')
      }, {
        id: 5,
        name: this.$t('designCategory2.permalink')
      }
      // {id:3,name:this.$t('designCategory2.myselfDefine')},
      ],
      settingType: undefined,
      classifityList: [],
      sort: undefined,
      showSort: true,
      picturePath: '',
      listTotal: 0,
      type: undefined,
      isEdit: false,
      firstcategroyId: null,
      leftId: null,
      showTreeLoading: false,
      parentID: null,
      // 配置文件的固定链接
      linkList: linkList
    };
  },
  computed: {
    synchronizedStockTimeStr: function synchronizedStockTimeStr() {
      return this.$t('designCategory2.remindcontent');
    },
    uploadLimit: function uploadLimit() {
      return localStorage.uploadLimit;
    }
  },
  watch: {},
  mounted: function mounted() {
    this.columns = this.firstColumns;
    this.getLfetList();
    this.getInitialValue();
    this.rowDrop();
  },
  methods: {
    getSettingType: function getSettingType(type) {
      switch (type) {
        case 0:
          return this.$t('designCategory2.oldPlace');
        case 1:
          return this.$t('designCategory2.transportWay');
        case 2:
          return this.$t('designCategory2.brand');
        case 3:
          return this.$t('designCategory2.myselfDefine');
        case 4:
          return this.$t('designCategory2.goodsClassifity');
        case 5:
          return this.$t('designCategory2.permalink');
      }
    },
    showFYBtn: function showFYBtn(categoryObj) {
      // 显示翻译
      // let self = this;
      // let categoryNameListClone = self.datavalue.list;
      // for (let one of categoryNameListClone) {
      // 	one.showNameFY = false;
      // }
      // self.datavalue.list = categoryNameListClone;
      // categoryObj.showNameFY = true;
    },
    /* 获取localStorage里面的默认语言 和系统设置中存的语言list */getInitialValue: function getInitialValue() {
      var _this3 = this;
      var self = this;
      self.defaultLangObj = JSON.parse(localStorage.getItem('defaultLangObj'));
      self.langList = JSON.parse(localStorage.getItem('langList'));
      var _iterator = _createForOfIteratorHelper(self.langList),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var item = _step.value;
          var nameObj = {};
          //因为编辑的是否需要id
          nameObj.id = '';
          nameObj.titleName = self.$t('designCategory2.categoryname') + '(' + item.langName + ')';
          //多语言id
          nameObj.langId = item.langId;
          //分类名称
          nameObj.name = "";
          if (item.langId == self.defaultLangObj.langId) {
            nameObj.required = true;
          } else {
            nameObj.required = false;
          }
          nameObj.showNameFY = false;
          self.categoryLangList.push(nameObj);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      self.datavalue.list = _.cloneDeep(self.categoryLangList);
      // 获取分类的下拉列表数据
      getCategoryIdAndNameList().then(function (res) {
        _this3.classifityList = res.data.data;
      });
    },
    //获取左侧的列表
    getLfetList: function getLfetList() {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var res;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _context.n = 1;
              return getLeftcategoryList();
            case 1:
              res = _context.v;
              if (res.data.code == 200) {
                _this4.newClass = res.data.data;
                _this4.newClass.forEach(function (item, index, arr) {
                  if (item.settingType == 5) {
                    arr[index].disabled = true;
                    arr[index].scopedSlots = {
                      title: 'link',
                      name: item.settingName
                    };
                  }
                });
                _this4.leftDateList = [{
                  settingName: _this4.$t('designCategory2.allClifity'),
                  id: '0',
                  childrenList: _this4.newClass
                }];
                _this4.expandedKeys = ['0'];
                //设置默认选中所有分类
                _this4.defaultSelectedKeys = ['0'],
                //页面初始化，默认获取所有分类底下的一级分裂
                _this4.getRightList(0);
              }
            case 2:
              return _context.a(2);
          }
        }, _callee);
      }))();
    },
    // 分类排序
    rowDrop: function rowDrop() {
      var tbody = document.querySelector('#first .ant-table-tbody'); // 元素选择器名称根据实际内容替换
      var _this = this;
      // let sort = Sortable.create(tbody)
      this.sort = Sortable.create(tbody, {
        onEnd: function onEnd(_ref) {
          var _this5 = this;
          return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
            var newIndex, oldIndex, currRow, newData, sortType, res;
            return _regenerator().w(function (_context2) {
              while (1) switch (_context2.n) {
                case 0:
                  newIndex = _ref.newIndex, oldIndex = _ref.oldIndex;
                  console.log(newIndex, oldIndex);
                  currRow = _this.firstClassifyList.splice(oldIndex, 1)[0];
                  console.log(currRow);
                  _this.firstClassifyList.splice(newIndex, 0, currRow);
                  newData = [];
                  _this.firstClassifyList.forEach(function (item, index, arr) {
                    item.settingOrder = index + 1;
                    newData.push(item);
                  });
                  console.log(newData, 11111111);
                  if (!(newIndex != oldIndex)) {
                    _context2.n = 5;
                    break;
                  }
                  // 更新数据接口
                  sortType = _this.defaultSelectedKeys[0] == 0 ? 0 : 1;
                  if (!_this5.sortOrderLoading) {
                    _context2.n = 1;
                    break;
                  }
                  return _context2.a(2);
                case 1:
                  _this5.sortOrderLoading = true;
                  _context2.p = 2;
                  _context2.n = 3;
                  return sortOrder(sortType, newData);
                case 3:
                  res = _context2.v;
                  if (res.data.code == 200) {
                    if (_this.defaultSelectedKeys[0] == 0) {
                      _this.getLfetList();
                    } else {
                      _this.getRightList(_this.leftId);
                    }
                    _this.$message.success(_this.$t('public.updateSuccessfully'));
                  }
                case 4:
                  _context2.p = 4;
                  _this5.sortOrderLoading = false;
                  return _context2.f(4);
                case 5:
                  return _context2.a(2);
              }
            }, _callee2, null, [[2,, 4, 5]]);
          }))();
        }
      });
    },
    stopDrop: function stopDrop() {
      this.sort.destroy();
    },
    /* 添加按钮 */addModal: function addModal() {
      this.isEdit = false;
      if (this.settingType == 3) {
        this.dialogStatus = 'createsecond';
      } else {
        this.dialogStatus = 'createfirst';
      }
      this.visible = true;
      this.saveLoading = false;
      this.resetdatavalue();
    },
    resetdatavalue: function resetdatavalue() {
      this.datavalue = {
        settingType: undefined,
        classifityType: undefined,
        link: this.linkList.goodsLink,
        list: _.cloneDeep(this.categoryLangList)
      };
      this.imageUrl = '';
    },
    //点击左侧树形结构，获取一级分类下面的子级
    onSelect: function onSelect(selectedKeys, e) {
      var _this6 = this;
      this.parentID = e.node.dataRef.productClassifyId;
      // e.node.dataRef 存储了这个节点的数据 可以通过这个数据的type来判断是什么类型 从而显示不同的二级列表
      this.settingType = e.node.dataRef.settingType;
      this.leftId = e.node.dataRef.id;
      if (selectedKeys.length > 0) {
        this.defaultSelectedKeys = selectedKeys;
        // this.getRightList(selectedKeys[0])
        if (this.settingType == 3 || this.defaultSelectedKeys[0] == 0) {
          if (!this.showSort) {
            setTimeout(function () {
              _this6.rowDrop();
              _this6.showSort = true;
            }, 0);
          }
        } else {
          if (this.showSort) {
            this.stopDrop();
            this.showSort = false;
          }
        }
        this.pagination = false;
        if (e.node.dataRef.settingType == 0) {
          this.columns = this.sourceColumns;
        } else if (e.node.dataRef.settingType == 1) {
          this.columns = this.transportColumns;
        } else if (e.node.dataRef.settingType == 2) {
          // 这里的数据需要返回序号
          this.pagination = this.secondPagination;
          this.columns = this.bindColumns;
        } else if (e.node.dataRef.settingType == 4) {
          this.columns = this.classifityColumns;
        } else if (e.node.dataRef.settingType == 3) {
          this.columns = this.myColumns;
        }
        if (selectedKeys[0] == 0) {
          this.columns = this.firstColumns;
          this.getRightList(0);
        } else {
          this.getRightList(this.leftId);
        }
      }
    },
    /* 根据父级id获取子集列表右侧的数据 */getRightList: function getRightList(id) {
      var _this7 = this;
      this.firstClassifyList = [];
      this.isTableLoading = true;
      this.showTreeLoading = true;
      var params = {
        page: this.secondPagination.current,
        size: this.secondPagination.pageSize
      };
      var params2 = {
        page: this.secondPagination.current,
        size: this.secondPagination.pageSize,
        brandStatus: 1
      };
      // 获取品牌列表
      if (this.settingType == 2) {
        getBrandList(params2).then(function (response) {
          if (response.data.code == 200) {
            _this7.firstClassifyList = response.data.data.list;
            _this7.secondPagination.total = response.data.data.total;
          }
        }).finally(function () {
          _this7.isTableLoading = false;
          _this7.showTreeLoading = false;
        });
      }
      // 获取运输方式
      else if (this.settingType == 1) {
        getTransportList().then(function (res) {
          if (res.data.code == 200) {
            _this7.firstClassifyList = res.data.data.filter(function (item) {
              return item.transportStatus == 0;
            });
          }
        }).finally(function () {
          _this7.isTableLoading = false;
          _this7.showTreeLoading = false;
        });
      }
      // 获取 原产地
      else if (this.settingType == 0) {
        getSoureareaList().then(function (res) {
          if (res.data.code == 200) {
            _this7.firstClassifyList = res.data.data.list.filter(function (item) {
              return item.status == 1;
            });
          }
        }).finally(function () {
          _this7.isTableLoading = false;
          _this7.showTreeLoading = false;
        });
      }
      // 获取二级分类
      else if (this.settingType == 4) {
        getCategoryListByParentId(Number(this.parentID)).then(function (res) {
          if (res.data.code == 200) {
            _this7.firstClassifyList = res.data.data;
          }
        }).finally(function () {
          _this7.isTableLoading = false;
          _this7.showTreeLoading = false;
        });
      }
      // 其他方式
      else {
        getRightcategoryList(Number(id), params).then(function (res) {
          if (res.data.code == 200) {
            _this7.firstClassifyList = res.data.data;
            // this.secondPagination.total = res.data.data.total
            // this.secondPagination.current = res.data.data.currentPage
          }
        }).finally(function () {
          _this7.isTableLoading = false;
          _this7.showTreeLoading = false;
        });
      }
    },
    /* 上传图片相关 */handleChange: function handleChange(info) {
      if (info.file.status === 'uploading') {
        this.loading = true;
        return;
      }
      if (info.file.status === 'done') {
        if (info.file.response.code == 200) {
          var picurl = info.file.response.data.uploadfilepath;
          var urlpath = info.file.response.data.urlpath;
          this.picturePath = picurl;
          this.imageUrl = urlpath + picurl;
          this.loading = false;
        }
      }
    },
    beforeUpload: function beforeUpload(file) {
      var isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
      if (!isJpgOrPng) {
        this.$message.error(this.$t('public.pictureType'));
      }
      var isLt2M = file.size / 1024 / 1024 < this.uploadLimit;
      if (!isLt2M) {
        this.$message.error(this.$t('public.pictureMax', {
          uploadLimit: this.uploadLimit
        }));
      }
      return isJpgOrPng && isLt2M;
    },
    /* 编辑按钮 */updata: function updata(record) {
      var _this8 = this;
      this.isEdit = true;
      this.firstcategroyId = record.id;
      if (this.settingType == 3) {
        this.dialogStatus = 'updatesecond';
      } else {
        this.dialogStatus = 'updatefirst';
      }
      // 调用接口拿到详细信息
      if (this.defaultSelectedKeys[0] == 0) {
        getCategoryDetail(record.id).then(function (response) {
          if (response.data.code == 200) {
            var dataNameList = response.data.data.settingNames;
            // this.datavalue.link = response.data.data.settingUrl
            // 赋值多语言名称
            var newNameList = _.cloneDeep(_this8.categoryLangList);
            var _iterator2 = _createForOfIteratorHelper(newNameList),
              _step2;
            try {
              var _loop = function _loop() {
                var initial = _step2.value;
                var findObj = _.find(dataNameList, function (o) {
                  return o.langId == initial.langId;
                });
                if (findObj) {
                  initial.id = findObj.id;
                  initial.name = findObj.name;
                }
              };
              for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                _loop();
              }
            } catch (err) {
              _iterator2.e(err);
            } finally {
              _iterator2.f();
            }
            _this8.datavalue.settingType = response.data.data.settingType;
            _this8.datavalue.classifityType = response.data.data.productClassifyId;
            _this8.datavalue.list = _.cloneDeep(newNameList);
            _this8.visible = true;
          }
        });
      } else {
        getSecondCategoryDetail(record.id).then(function (response) {
          if (response.data.code == 200) {
            var dataNameList = response.data.data.settingNames;
            _this8.datavalue.link = response.data.data.dataUrl;
            // 赋值多语言名称
            var newNameList = _.cloneDeep(_this8.categoryLangList);
            var _iterator3 = _createForOfIteratorHelper(newNameList),
              _step3;
            try {
              var _loop2 = function _loop2() {
                var initial = _step3.value;
                var findObj = _.find(dataNameList, function (o) {
                  return o.langId == initial.langId;
                });
                if (findObj) {
                  initial.id = findObj.id;
                  initial.name = findObj.name;
                }
              };
              for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
                _loop2();
              }
            } catch (err) {
              _iterator3.e(err);
            } finally {
              _iterator3.f();
            }
            _this8.imageUrl = response.data.data.urlPath + response.data.data.dataImg;
            _this8.picturePath = response.data.data.dataImg;
            _this8.datavalue.list = _.cloneDeep(newNameList);
            _this8.visible = true;
          }
        });
      }
    },
    /* 确定更新 */updateUser: function updateUser() {
      var _this9 = this;
      var params = {
        settingNames: this.datavalue.list,
        settingUrl: this.datavalue.link
      };
      this.$refs.dataForm.validate(function (valid) {
        if (valid) {
          _this9.updateLoading = true;
          // 调用编辑接口
          if (_this9.defaultSelectedKeys[0] == 0) {
            editFirstcategory(_this9.firstcategroyId, params).then(function (response) {
              if (response.data.code == 200) {
                if (_this9.defaultSelectedKeys[0] == 0) {
                  _this9.getLfetList();
                } else {
                  //刷新右侧的树形结构
                  _this9.getRightList(_this9.leftId);
                }
                _this9.$message.success(_this9.$t('public.updateSuccessfully'));
              }
            }).finally(function () {
              _this9.updateLoading = false;
              _this9.visible = false;
            });
          } else {
            var params2 = {
              settingNames: _this9.datavalue.list,
              dataUrl: _this9.datavalue.link,
              dataImg: _this9.picturePath
            };
            editSecondCategory(_this9.firstcategroyId, params2).then(function (response) {
              if (response.data.code == 200) {
                if (_this9.defaultSelectedKeys[0] == 0) {
                  _this9.getLfetList();
                } else {
                  //刷新右侧的树形结构
                  _this9.getRightList(_this9.leftId);
                }
                _this9.$message.success(_this9.$t('public.updateSuccessfully'));
              }
            }).finally(function () {
              _this9.updateLoading = false;
              _this9.visible = false;
            });
          }
        }
      });
    },
    /* 取消按钮 */resetFormDate: function resetFormDate() {
      this.visible = false;
      this.resetdatavalue();
    },
    // 确定删除
    confirm: function confirm(id) {
      var _this0 = this;
      if (this.defaultSelectedKeys[0] == 0) {
        deleteFirstcategory(id).then(function (response) {
          if (response.data.code == 200) {
            _this0.getLfetList();
            _this0.$message.success(_this0.$t('public.deleteSuccessfully'));
          }
        });
      } else {
        deleteSecondcategory(id).then(function (response) {
          if (response.data.code == 200) {
            _this0.getRightList(_this0.leftId);
            _this0.$message.success(_this0.$t('public.deleteSuccessfully'));
          }
        });
      }
    },
    cancel: function cancel(e) {
      // this.$message.error('取消删除了');
    },
    /* 确定添加 一级/二级分类*/saveCategory: function saveCategory() {
      var _this1 = this;
      var self = this;
      self.$refs.dataForm.validate(/*#__PURE__*/function () {
        var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(valid) {
          var params, res, params2, _res;
          return _regenerator().w(function (_context3) {
            while (1) switch (_context3.n) {
              case 0:
                if (!valid) {
                  _context3.n = 4;
                  break;
                }
                _this1.saveLoading = true;
                if (!(_this1.defaultSelectedKeys[0] == 0)) {
                  _context3.n = 2;
                  break;
                }
                // 调用接口
                params = {
                  settingType: _this1.datavalue.settingType,
                  settingNames: _this1.datavalue.list,
                  settingUrl: _this1.datavalue.link,
                  productClassifyIds: _this1.datavalue.classifityType ? _this1.datavalue.classifityType.join(',') : ''
                };
                _context3.n = 1;
                return addFirstcategory(params);
              case 1:
                res = _context3.v;
                try {
                  if (res.data.code == 200) {
                    _this1.getLfetList();
                    _this1.$message.success(_this1.$t('public.addSuccessfully'));
                    _this1.visible = false;
                  }
                } catch (err) {
                  _this1.$message.error(err);
                } finally {
                  _this1.saveLoading = false;
                }
                _context3.n = 4;
                break;
              case 2:
                params2 = {
                  settingNames: _this1.datavalue.list,
                  dataUrl: _this1.datavalue.link,
                  dataImg: _this1.picturePath
                };
                _context3.n = 3;
                return addSecondcategory(_this1.leftId, params2);
              case 3:
                _res = _context3.v;
                try {
                  if (_res.data.code == 200) {
                    _this1.getRightList(_this1.leftId);
                    _this1.$message.success(_this1.$t('public.addSuccessfully'));
                    _this1.visible = false;
                  }
                } catch (err) {
                  _this1.$message.error(err);
                } finally {
                  _this1.saveLoading = false;
                }
              case 4:
                return _context3.a(2);
            }
          }, _callee3);
        }));
        return function (_x) {
          return _ref2.apply(this, arguments);
        };
      }());
    }
  }
};